import Vue from 'vue';

const success = (context, response) => {
  context.formImageUploaded = true;
  context.formImage.path = null;
  // $(".photo-content .dropify-preview").hide();
};

const failed = (context, error) => {
  console.log(error);
  context.formImageUploaded = true;
};

export default (context, id) => {
  return Vue.$http.delete('delete-form-image/'+id).then(response => {
    if(response && response.status === 200 ) {
      success(context, response);
    }
  }).catch(error => {
    failed(context, error);
  });
}



// WEBPACK FOOTER //
// ./src/app/services/form/deleteFormImage.js